import React from 'react';

interface UnderlinedTextProps {
    text: string;
}

function UnderlinedText(props: UnderlinedTextProps): JSX.Element {
    const {text} = props;

    return (
        <div className="c-textUnderline">
            <div className="c-textUnderline__line" />
            <div className="c-textUnderline__data">{text}</div>
        </div>
    );
}

export default UnderlinedText;
